// removed by extract-text-webpack-plugin
module.exports = {"container":"hobnob-hud__container__3KnYi","message":"hobnob-hud__message__3vXrB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/hobnob-hud.scss
// module id = 1248
// module chunks = 1